import { forwardRef, useState } from 'react'

import { Visibility } from 'globalTypes'

import { Dialog } from '@headlessui/react'
import { Trans } from '@lingui/macro'
import Button from 'Root/App/Button'
import ShareMine from 'Root/App/Item/ShareMine'
import ShareNeedRegistration from 'Root/App/Item/ShareNeedRegistration'
import SharePrivate from 'Root/App/Item/SharePrivate'
import ShareWorld from 'Root/App/Item/ShareWorld'
import Title from 'Root/App/Title'

import PanelLayout from '../../PanelLayout'
import styles from './index.module.css'

interface Props {
  visibility: Visibility
  need_registration?: boolean
  onClose: () => void
  onSave: (visibility: Visibility, need_registration: boolean) => void
}

export type Ref = HTMLDivElement

const Options = ({ visibility, need_registration, onClose, onSave }: Props) => {
  const [optionSelected, setOptionSelected] = useState({
    visibility: visibility,
    need_registration: need_registration,
  })

  const handleSave = () => {
    onSave(optionSelected.visibility, optionSelected.need_registration)
    onClose()
  }

  const callToActionButtons = (
    <>
      <Button className={styles.choiceCancelButton} onClick={onClose}>
        <Title size="2XS" className={styles.choiceCancelButtonText}>
          <Trans>Annulla</Trans>
        </Title>
      </Button>
      <Button className={styles.choiceSaveButton} onClick={handleSave}>
        <Title size="2XS" className={styles.choiceSaveButtonText}>
          <Trans>Conferma</Trans>
        </Title>
      </Button>
    </>
  )

  return (
    <PanelLayout
      title={<Trans>Condividi</Trans>}
      cta={callToActionButtons}
      onClose={onClose}
    >
      <span className={styles.optionsWrapper}>
        <ShareMine
          active={optionSelected.visibility === Visibility.mine}
          onClick={() =>
            setOptionSelected({
              visibility: Visibility.mine,
              need_registration: false,
            })
          }
        />
        <SharePrivate
          active={optionSelected.visibility === Visibility.private}
          onClick={() =>
            setOptionSelected({
              visibility: Visibility.private,
              need_registration: false,
            })
          }
        />
        <ShareWorld
          active={
            optionSelected.visibility === Visibility.public &&
            !optionSelected.need_registration
          }
          onClick={() =>
            setOptionSelected({
              visibility: Visibility.public,
              need_registration: false,
            })
          }
        />

        <ShareNeedRegistration
          active={
            optionSelected.visibility === Visibility.public &&
            optionSelected.need_registration
          }
          onClick={() =>
            setOptionSelected({
              visibility: Visibility.public,
              need_registration: true,
            })
          }
        />
      </span>
    </PanelLayout>
  )
}

const ShareOptions = forwardRef<Ref, Props>(function ShareOptions(
  { visibility, need_registration, onClose, onSave },
  ref
) {
  return (
    <>
      <Dialog.Panel className={styles.dialogPanel} ref={ref}>
        <Options
          visibility={visibility}
          need_registration={need_registration}
          onClose={onClose}
          onSave={onSave}
        />
      </Dialog.Panel>
    </>
  )
})

export default ShareOptions
